<!-- <sc-chatbot-answer-custom *ngIf="message.Type == 'Custom'" [message]="message"></sc-chatbot-answer-custom> -->

@if (message && message.Type != 'Custom' && !(message.Type == 'None' && message.Direction == 'UserToBot')) {
  <div class="chatbot-message sender-user"
    [class.sender-user]="isOwnMessage"
    [class.sender-server]="!isOwnMessage"
    [@messageAnimate]="_visible"
    [class.is-history]="message?.History">
    <div class="message-wrapper">
      @if (message.Sender && !isOwnMessage) {
        <sc-avatar class="message-avatar" size="xs" [user]="message.Sender"></sc-avatar>
      }
      <div class="message-content">
        @if (message.Sender) {
          <div class="message-sender">
            {{ message.Sender.FirstName }} {{ message.Sender.LastName }}
          </div>
        }
        <div class="message-body">
          @if (message.Direction != 'UserToBot') {
            <sc-chatbot-answer-text [message]="message"></sc-chatbot-answer-text>
          }
          @if (message.Type == 'YesNo' && message.Direction == 'UserToBot') {
            <sc-chatbot-answer-text [message]="message"></sc-chatbot-answer-text>
          }
          @if (message.Type == 'Text' && message.Direction == 'UserToBot') {
            <sc-chatbot-answer-text [message]="message"></sc-chatbot-answer-text>
          }
          @if (message.Type == 'Choice' && message.Direction == 'UserToBot') {
            <sc-chatbot-answer-choice [message]="message"></sc-chatbot-answer-choice>
          }
          @if (message.Type == 'Location' && message.Direction == 'UserToBot') {
            <sc-chatbot-answer-map [message]="message"></sc-chatbot-answer-map>
          }
          @if (message.Type == 'FileUpload' && message.Direction == 'UserToBot' && !message.Payload?.IsQuickReply) {
            <sc-chatbot-answer-file-upload [message]="message"></sc-chatbot-answer-file-upload>
          }
          @if (message.Type == 'FileUpload' && message.Direction == 'UserToBot' && message.Payload?.IsQuickReply) {
            <sc-chatbot-answer-text [message]="message"></sc-chatbot-answer-text>
          }
          @if (message.Type == 'Range' && message.Direction == 'UserToBot') {
            <sc-chatbot-answer-range [message]="message"></sc-chatbot-answer-range>
          }
        </div>
        @if (isOwnMessage) {
          <div class="message-status">
            <div class="check-icon" [class.show]="message.isSent">
              <i class="fa-sharp fa-solid fa-circle-check me-2"></i>
            </div>
            @if (message.hasSendingFailed) {
              <a class="badge badge-danger-soft mt-2" (click)="resendMessage()">
                Fehler! Erneut senden.
              </a>
            }
          </div>
        }
      </div>
    </div>
    @if (message.Payload?.QuickReplies?.length) {
      <div class="quick-replies me-n2" [class.out]="!canQuickReply">
        @for (quickReply of message.Payload?.QuickReplies; track quickReply) {
          <div class="d-inline-block me-2 mb-2">
            <button class="btn btn-secondary btn-sm btn-round" (click)="sendQuickReply(quickReply)" [disabled]="!canQuickReply">{{ quickReply.Label }} </button>
          </div>
        }
      </div>
    }
  </div>
}
